export const reloadedToUpdateStorageKey = 'reloadedToUpdate';
export const oneDayInMs = 24 * 60 * 60 * 1000;
export const tenMinutesInMs = 10 * 60 * 1000;
